import { jsxs, jsx } from 'react/jsx-runtime';
import { cn } from '../../lib/utils.js';
import { Images } from '../../assets/ui/images/icons/index.js';

const Empty = ({
  variants = "empty",
  text,
  description,
  iconUrl = Images.Empty,
  strong,
  className
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex flex-col justify-center items-center mt-8 p-5 pt-5 md:px-6",
        variants === "message" && "h-[160px] border border-basic-04 rounded-[12px]",
        className
      ),
      children: [
        variants !== "message" && /* @__PURE__ */ jsx(
          "span",
          {
            className: cn(
              "block text-center",
              variants === "empty" ? "w-[108px] mx-auto h-[88px]" : "w-[80px] mx-auto h-[80px]"
            ),
            "aria-hidden": "true",
            children: /* @__PURE__ */ jsx("img", { src: iconUrl, alt: "", className: "ml-auto w-full" })
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: cn(
              "flex flex-col text-center",
              variants !== "message" ? "mt-4 gap-2" : "gap-1"
            ),
            children: [
              text && /* @__PURE__ */ jsxs(
                "p",
                {
                  className: cn(
                    "whitespace-pre-line text-basic-02",
                    variants === "message" ? "body-md text-basic-04 font-weight-medium" : "body-lg font-weight-medium"
                  ),
                  children: [
                    strong,
                    text
                  ]
                }
              ),
              description && /* @__PURE__ */ jsx(
                "p",
                {
                  className: cn(
                    "whitespace-pre-line",
                    variants === "message" ? "text-basic-05 body-sm font-weight-medium break-keep" : "text-basic-04 body-md break-keep"
                  ),
                  children: description
                }
              )
            ]
          }
        )
      ]
    }
  );
};

export { Empty };
